import { render, staticRenderFns } from "./FactureCeder.vue?vue&type=template&id=9ab7fb8c&scoped=true&"
import script from "./FactureCeder.vue?vue&type=script&lang=ts&"
export * from "./FactureCeder.vue?vue&type=script&lang=ts&"
import style0 from "./FactureCeder.vue?vue&type=style&index=0&id=9ab7fb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab7fb8c",
  null
  
)

export default component.exports